import Wrapper from './Wrapper'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  routeName: state.router.activeRoute.name,
  content: state.article?.content,
  category: state.category?.category,
})

export default connect(mapStateToProps)(Wrapper)
